import { getInstance } from '@/auth/authWrapper'
import cfg from '@root/config'
import { Connector } from '../../types/main'

export interface WaitThaiSalon {
    id: number
    name: string
    timezone: string
}
export interface WaitThaiApiError {
    code: string
    message: string
    status: number
}
export interface WaitThaiResult<T> {
    data: T | null
    error: WaitThaiApiError | null
}
export interface WaitThaiCredentials {
    host: string
    token: string
}

// Токен партнёра (credentials.token) нельзя писать в логи/console.
async function post<T>(path: string, payload: Record<string, unknown>): Promise<WaitThaiResult<T>> {
    let res: Response
    try {
        const authToken = await getInstance().getTokenSilently()
        res = await fetch(`${cfg.apiEndpoint}/waitThai/${path}`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify(payload),
        })
    } catch (e) {
        return {
            data: null,
            error: { code: 'NETWORK', message: 'Не удалось выполнить запрос', status: 0 },
        }
    }
    if (res.ok) {
        const data = await res.json().catch(() => null)
        if (data) {
            return { data: data as T, error: null }
        }
        return {
            data: null,
            error: { code: 'WAITTHAI_INTERNAL', message: 'Не удалось выполнить запрос', status: res.status },
        }
    }
    const body = await res.json().catch(() => null)
    return {
        data: null,
        error: {
            code: body?.error?.code ?? 'WAITTHAI_INTERNAL',
            message: body?.error?.message ?? 'Не удалось выполнить запрос',
            status: res.status,
        },
    }
}

export function login(
    connector: Connector,
    credentials: WaitThaiCredentials
): Promise<WaitThaiResult<{ salons: WaitThaiSalon[] }>> {
    return post('login', { connector, credentials })
}

export function connect(
    connector: Connector,
    credentials: WaitThaiCredentials,
    salonId: number
): Promise<WaitThaiResult<{ connector: Connector }>> {
    return post('connect', { connector, credentials, salonId })
}
